// extracted by mini-css-extract-plugin
export default {"container":"Timer_container__NECeR","img":"Timer_img__OhcYd","text":"Timer_text__DT6oC","time":"Timer_time__tPyMJ"};